import React from 'react';
import { Badge, Button, Col, Form, Modal, Row, Select, Space } from 'antd';
import { ClearOutlined, FilterOutlined } from '@ant-design/icons';

const { Option } = Select;

// Datos mock — se reemplazarán con llamadas al API
const MOCK_IDS          = ['43', '44', '45', '46'];
const MOCK_LOCATIONS    = ['Ecuador', 'Guatemala'];
const MOCK_ESTADOS      = ['Traducida', 'Traduciendo', 'Enviada'];
const MOCK_SOLICITANTES = ['Karen Perez', 'Hilda García'];

interface FiltersTraductorProps {
  openModal: boolean;
  setOpenModal: (open: boolean) => void;
  filterApply: any;
  onFinish: (values: any) => void;
  cleanFilters: () => void;
}

const FiltersTraductor: React.FC<FiltersTraductorProps> = ({
  filterApply,
  onFinish,
  cleanFilters,
  openModal,
  setOpenModal,
}) => {
  const [form] = Form.useForm();

  const handleClear = () => {
    form.resetFields();
    cleanFilters();
  };

  return (
    <Col>
      <Space>
        <Badge dot={Object.keys(filterApply).length > 0}>
          <Button icon={<FilterOutlined />} onClick={() => setOpenModal(true)}>
            Filtros
          </Button>
        </Badge>
        {Object.keys(filterApply).length > 0 && (
          <Button type="primary" danger ghost icon={<ClearOutlined />} onClick={handleClear}>
            Limpiar filtros
          </Button>
        )}
      </Space>

      <Modal
        centered
        width={700}
        title="Filtros"
        open={openModal}
        onCancel={() => setOpenModal(false)}
        footer={
          <Row justify="space-between">
            <Col>
              <Button shape="round" type="primary" danger ghost onClick={handleClear}>
                Borrar filtros
              </Button>
            </Col>
            <Col>
              <Space>
                <Button shape="round" type="text" onClick={() => setOpenModal(false)}>
                  Cancelar
                </Button>
                <Button shape="round" type="primary" onClick={() => form.submit()}>
                  Aplicar filtros
                </Button>
              </Space>
            </Col>
          </Row>
        }
      >
        <Form layout="vertical" form={form} onFinish={onFinish}>
          <Row gutter={[16, 0]}>

            <Col span={24} md={12}>
              <Form.Item name="idSolicitud" label="ID Solicitud">
                <Select
                  mode="multiple"
                  allowClear
                  showSearch
                  placeholder="Seleccione IDs"
                  listHeight={120}
                >
                  {MOCK_IDS.map(id => (
                    <Option key={id} value={id}>{id}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={24} md={12}>
              <Form.Item name="estado" label="Estado">
                <Select
                  mode="multiple"
                  allowClear
                  showSearch
                  placeholder="Seleccione estados"
                  listHeight={120}
                >
                  {MOCK_ESTADOS.map(e => (
                    <Option key={e} value={e}>{e}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={24} md={12}>
              <Form.Item name="localizacion" label="Localización">
                <Select
                  mode="multiple"
                  allowClear
                  showSearch
                  placeholder="Seleccione países"
                  listHeight={120}
                >
                  {MOCK_LOCATIONS.map(loc => (
                    <Option key={loc} value={loc}>{loc}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={24} md={12}>
              <Form.Item name="solicitante" label="Solicitante">
                <Select
                  mode="multiple"
                  allowClear
                  showSearch
                  placeholder="Seleccione solicitantes"
                  listHeight={120}
                >
                  {MOCK_SOLICITANTES.map(s => (
                    <Option key={s} value={s}>{s}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

          </Row>
        </Form>
      </Modal>
    </Col>
  );
};

export default FiltersTraductor;
